<template>
	<c-dialog ref="dialog" title="送修记录详情" height="70vh" :button="false">
		<c-title style="margin: .3rem .3rem 0;">送修信息</c-title>
		<c-detail style="padding-top: 0;">
			<c-detail-item label="背贴码">
				{{delivery.produce_unique_code || '-'}}
			</c-detail-item>
			<c-detail-item label="型号">
				{{delivery.model_name || '-'}}
			</c-detail-item>
			<c-detail-item label="IMEI">
				{{delivery.produce_imei || '-'}}
			</c-detail-item>
			<c-detail-item label="维修单位">
				{{delivery.repair_unit || '-'}}
			</c-detail-item>
			<c-detail-item label="送修人">
				{{delivery.sender_user_name || '-'}}
			</c-detail-item>
			<c-detail-item label="维修金额">
				<span style="color: #FF6900;">￥{{totalAmount}}</span>
			</c-detail-item>
			<c-detail-item label="状态">
				{{delivery.delivery_state == 2 ? '送修完成' : '送修中'}}
			</c-detail-item>
			<c-detail-item label="送修时间">
				{{delivery.delivery_date || '-'}}
			</c-detail-item>
			<c-detail-item v-if="delivery.delivery_state == 2" label="送修完成时间">
				{{delivery.complete_date || '-'}}
			</c-detail-item>
			<c-detail-item v-if="delivery.delivery_state == 2" label="送修时长">
				{{duration}}
			</c-detail-item>
			<c-detail-item label="备注">
				{{delivery.remark || '-'}}
			</c-detail-item>
		</c-detail>

		<c-title style="margin: 0 .3rem;" v-if="delivery.delivery_state == 2">维修项目</c-title>
		<c-detail v-if="delivery.delivery_state == 2">
			<c-detail-item v-for="(item, i) in details" :key="i" :label="getItemName(item.repair_item)">
				￥{{item.repair_amount}}
			</c-detail-item>
		</c-detail>
	</c-dialog>
</template>

<script>
	export default {
		name: 'repairDeliveryDetail',

		props: {
			id: [String, Number]
		},

		data() {
			return {
				delivery: {},
				details: [],
				/*维修项字典，明细表只存 repair_item 代码，label 要显示名称*/
				itemOptions: []
			}
		},

		computed: {
			// 明细金额合计，含负数冲减项
			totalAmount() {
				return this.details.reduce((sum, item) => sum + Number(item.repair_amount || 0), 0).toFixed(2);
			},

			// 送修时长：从送修时间算到完成时间，未完成的算到现在
			duration() {
				if (!this.delivery.delivery_date) return '-';
				let end = this.delivery.complete_date ? new Date(this.delivery.complete_date) : new Date();
				let days = Math.ceil((end - new Date(this.delivery.delivery_date)) / (1000 * 60 * 60 * 24));
				return (days < 0 ? 0 : days) + '天';
			}
		},

		methods: {
			open() {
				this.loadItemOptions();
				this.request({
					url: '/repair/delivery/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.delivery = data.delivery || {};
						this.details = data.details || [];
						this.$refs.dialog.open();
					}
				});
			},

			loadItemOptions() {
				if (this.itemOptions.length) return;
				this.request({
					url: '/system/dic/options',
					data: {
						dic_type_code: 'REPAIR_ITEM'
					},
					success: data => {
						this.itemOptions = data || [];
					}
				});
			},

			getItemName(item) {
				let matched = this.itemOptions.find(option => option.value == item);
				return matched ? matched.name : '-';
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
